(function () {
  function initialiseHeader(header) {
    if (header.dataset.plReady) return;
    var toggle = header.querySelector('[data-pl-menu]');
    var dialog = header.querySelector('[data-pl-mobile-dialog]');
    if (!toggle || !dialog || typeof dialog.showModal !== 'function') return;
    header.dataset.plReady = 'true';
    var desktop = window.matchMedia('(min-width: 1051px)');
    var disclosures = Array.from(header.querySelectorAll('[data-pl-disclosure]'));
    var scrollPosition = 0;
    var locked = false;
    function closeDesktop(except) {
      disclosures.forEach(function (item) { if (item !== except) item.open = false; });
    }
    function restorePage() {
      toggle.setAttribute('aria-expanded', 'false');
      if (!locked) return;
      locked = false;
      document.body.classList.remove('pl-menu-is-open');
      document.body.style.removeProperty('--pl-menu-scroll-top');
      window.scrollTo(0, scrollPosition);
    }
    function closeMobile() {
      if (dialog.open) dialog.close();
      restorePage();
    }
    toggle.addEventListener('click', function () {
      if (desktop.matches) return;
      closeDesktop();
      scrollPosition = window.scrollY;
      dialog.showModal();
      locked = true;
      document.body.style.setProperty('--pl-menu-scroll-top', '-' + scrollPosition + 'px');
      document.body.classList.add('pl-menu-is-open');
      toggle.setAttribute('aria-expanded', 'true');
    });
    dialog.querySelector('[data-pl-menu-close]').addEventListener('click', closeMobile);
    dialog.addEventListener('close', restorePage);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('a')) closeMobile();
    });
    dialog.addEventListener('submit', closeMobile);
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary'))
        .filter(function (element) { return element.getClientRects().length && element.tabIndex >= 0; });
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    dialog.querySelectorAll('details').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        dialog.querySelectorAll('details').forEach(function (sibling) { if (sibling !== item) sibling.open = false; });
      });
    });
    disclosures.forEach(function (item) {
      item.addEventListener('toggle', function () { if (item.open) closeDesktop(item); });
    });
    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || dialog.open) return;
      var open = disclosures.find(function (item) { return item.open; });
      if (open) { closeDesktop(); open.querySelector('summary').focus(); event.preventDefault(); }
    });
    document.addEventListener('click', function (event) {
      if (!header.contains(event.target) || event.target.closest('a')) closeDesktop();
    });
    header.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!header.contains(document.activeElement)) closeDesktop();
      }, 0);
    });
    desktop.addEventListener('change', function () { closeMobile(); closeDesktop(); });
    window.addEventListener('pagehide', closeMobile);
    window.addEventListener('pageshow', function (event) {
      // Only restored pages can carry stale menus; first-load interaction must survive.
      if (event.persisted) { closeMobile(); closeDesktop(); }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(header)) closeMobile();
    });
  }
  document.querySelectorAll('[data-pl-header]').forEach(initialiseHeader);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-pl-header]').forEach(initialiseHeader);
  });
})();

// Follow Aura's documented cart events so the custom header stays in sync.
document.addEventListener('theme:cart:change', function (event) {
  var count = event.detail && event.detail.cartItemCount;
  if (typeof count !== 'number') return;
  document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) { el.textContent = String(count); });
  document.querySelectorAll('[data-pl-bag]').forEach(function (el) { el.setAttribute('aria-label', 'Shopping bag, ' + count + (count === 1 ? ' item' : ' items')); });
});
